import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=585a280f&"
import script from "./Slider.vue?vue&type=script&lang=ts&"
export * from "./Slider.vue?vue&type=script&lang=ts&"
import style0 from "./Slider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports